// removed by extract-text-webpack-plugin
module.exports = {"containerSlider":"_3lSsWtPbM0MkFj6C_Wj-ez","line":"bgMD2EIBWsAocuxRKQt47","logoWrapper":"A2DfN-JTrZDbYcy3MeuIA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingLogosCarousel/LandingLogosCarousel.scss
// module id = 1618
// module chunks = 0